const initialState = {
    data: [],
    isFetching: false,
    isFetched: false,
    statusMessage: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'USERS_RESET':
            return initialState;
        case 'GET_USERS_REQUEST':
            return {
                state, ...{
                    isFetching: true,
                    isFetched: false,
                    statusMessage: ""
                }
            };
        case 'GET_USERS_SUCCESS':
            return {
                data: action.data,
                isFetching: false,
                isFetched: true,
                statusMessage: ""
            };
        case 'GET_USERS_FAILURE':
            return {
                state, ...{
                    isFetching: false,
                    isFetched: false,
                    statusMessage: action.error
                }
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/users.js